import PropTypes from "prop-types";
import { useState } from "react";
import ChevronArrow from "../assets/ChevronArrow";

// Search results component that displays a list of locations
const SearchResults = ({ locations, handleFormReset }) => {
  const [isListVisible, setIsListVisible] = useState(false); // State to control list visibility

  const toggleVisibility = () => {
    setIsListVisible((prev) => !prev); // Toggle the visibility state
  };

  // Conditionally set the class name based on visibility
  const buttonClassName = isListVisible
    ? "btn search-results-toggle open"
    : "btn search-results-toggle closed"; // Change class based on visibility

  const resultsClassName = isListVisible
    ? "search-results open"
    : "search-results closed"; // Change class based on visibility

  return (
    <div className={resultsClassName}>
      <div className="buttons">
        <button onClick={toggleVisibility} className={buttonClassName}>
          {isListVisible ? (
            <>
              Hide Results <ChevronArrow direction="up" />
            </>
          ) : (
            <>
              Show Results <ChevronArrow direction="down" />
            </>
          )}
        </button>
        <button
          className="btn reset-search"
          type="button"
          onClick={handleFormReset} // Trigger the form reset
          aria-label="Reset form"
        >
          Reset
        </button>
      </div>
      {isListVisible && (
        <div className="wrapper">
          <div className="row">
            <div className="col">
              <ul className="the-results">
                {locations.length > 0 ? (
                  locations.map((location, index) => (
                    <li key={index} className="location-item">
                      <h3>{location.company}</h3>
                      <p>{location.brands[0].brand_name}</p>
                      <p>{location.address}</p>
                      <p>
                        {location.city}, {location.state} {location.postal_code}
                      </p>
                      <p>Distance: {location.distance_mi} miles</p>
                      <p>
                        Phone:{" "}
                        <a href="tel:{location.phone}">{location.phone}</a>
                      </p>
                    </li>
                  ))
                ) : (
                  <li>No locations found.</li>
                )}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchResults;

SearchResults.propTypes = {
  locations: PropTypes.array.isRequired,
  handleFormReset: PropTypes.func.isRequired,
};
